import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Worksheet, WorksheetItem, WorksheetQuery, WorksheetService, WorksheetType } from '@fgb/core';

@Component({
  selector: 'fgb-worksheet-list',
  templateUrl: './worksheet-list.component.html',
  styleUrls: ['./worksheet-list.component.scss'],
})
export class WorksheetListComponent implements OnInit {
  isList: boolean = true;
  isWorksheetItems: boolean = false;
  currentItem: WorksheetItem;
  worksheetId: number;
  @ViewChild('outlet', { read: ViewContainerRef }) outletRef: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef }) contentRef: TemplateRef<any>;
  isTV: boolean = false;
  worksheetType = WorksheetType;
  firstVideoItem: WorksheetItem | undefined;
  listVideos: WorksheetItem[] | undefined;
  isPlaying: Boolean = false;
  hasItems: boolean = false;

  worksheets$ = this.worksheetQuery.getWorksheetByRoute(this.router.url.replace('/', ''));

  constructor(private worksheetService: WorksheetService, private worksheetQuery: WorksheetQuery, private router: Router) {}

  ngOnInit() {
    if (this.router.url === '/tv') this.isTV = true;

    if (!this.worksheetQuery.hasRoute(this.router.url.replace('/', ''))) {
      this.worksheetService.fetchWorksheetByRoute(this.router.url.replace('/', '')).toPromise();
    }
    this.worksheets$.subscribe((data) => {
      if (data.length > 0) {
        const activeItems = this.getActiveItems(data);
        if (activeItems.length > 0) {
          this.hasItems = true;
          this.isWorksheetItems = false;
          this.currentItem = activeItems[0];
        } else {
          this.isWorksheetItems = true;
        }
        data.map((item) => {
          if (item.WorksheetId) {
            this.worksheetId = item.WorksheetId;
          }
        });
      }
    });
  }

  private getActiveItems(worksheets: Worksheet[]): WorksheetItem[] {
    return worksheets.flatMap((group: Worksheet) => group.Items.filter((item) => item.WorksheetType === 2 && item.Active === 1));
  }

  selectWorksheetItem(worksheetItem: WorksheetItem) {
    this.currentItem = worksheetItem;
    this.isPlaying = true;
    this.rerender();
  }

  hasWorksheetType(items: WorksheetItem[], value: number): boolean {
    const filteredItems = items.filter((item) => item.WorksheetType === value);
    if (filteredItems.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  rerender() {
    this.outletRef.clear();
    this.outletRef.createEmbeddedView(this.contentRef);
  }
}
